module.exports = __webpack_public_path__ + "img/40_33.0c068bd3.png";